import { PurchaseOrder } from "Features/pages/purchaseOrders/types/PurchaseOrder.interfaces"
import { AuthzService } from "Shared/services"
import { OptionButtons, OptionButtonsPropsBase } from "Components/OptionButtons"

export const PurchaseOrderOptionButtons = <T extends Pick<PurchaseOrder, "state">>({ record, onEdit, onDelete, onView, children }: OptionButtonsPropsBase<T>) => {
    // Check if the current user can edit this purchase order
    const isEditDisabled = !AuthzService.isLoggedInUserAllowedToUpdatePurchaseOrder(record as unknown as PurchaseOrder)
    const isDeleteDisabled = !AuthzService.isLoggedInUserAllowedToDeletePurchaseOrder(record as unknown as PurchaseOrder)

    return OptionButtons<T>({ record, onEdit, onDelete, onView, children, isEditDisabled, isDeleteDisabled })
}
